import 'reflect-metadata';

import '@/assets/css/main.css'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'material-icons/iconfont/material-icons.css'
import axios from 'axios'
import { localize } from 'vee-validate'
// @ts-ignore
import en from 'vee-validate/dist/locale/en'
// @ts-ignore
import ru from 'vee-validate/dist/locale/ru'
import 'video.js/dist/video-js.min.css'

import Vue, { PluginFunction, VNode } from 'vue'

// @ts-ignore
import checkView from 'vue-check-view'
import { DynamicReactiveRefs, ReactiveRefs } from 'vue-reactive-refs'
import VueScreen from 'vue-screen'
// @ts-ignore
import { VueHammer } from 'vue2-hammer'
import vuescroll from 'vuescroll'
import App from './App.vue'
import './globalComponents.js'
import i18n from './i18n/i18n'
import router from './router/index'
import store from './store/store'
import isMobile from 'piramis-js-utils/lib/isMobile'
// @ts-ignore
import { Plugin } from 'vue-fragment'

// @ts-ignore
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'

import RouteHelpers from 'piramis-base-components/src/plugins/RouteHelpers/index'
import AdminTemplate from 'piramis-base-components/src/plugins/AdminTemplate'
import { AdminTemplateOptions } from 'piramis-base-components/src/plugins/AdminTemplate/includes/types/Config'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'piramis-base-components/src/assets/scss/main.scss'
import { BaseTemplateConfig } from "@/includes/BaseTemplateConfig";

Vue.use(Antd)

// Feather font icon
require('./assets/css/iconfont.css')

localize({
    ru,
    en,
})

localize(i18n.locale)

Vue.use(RouteHelpers as unknown as PluginFunction<any>, { router })

Vue.use(VueAwesomeSwiper)
Vue.use(Plugin)
Vue.use(checkView)
Vue.use(VueScreen, 'tailwind')
Vue.use(vuescroll)
Vue.prototype.$http = axios
Vue.use(VueHammer)
Vue.use(DynamicReactiveRefs)
Vue.use(ReactiveRefs)

const adminTemplateOptions: AdminTemplateOptions = {
    config: BaseTemplateConfig,
    router: router,
    store: store,
}

Vue.use(AdminTemplate as unknown as PluginFunction<any>, adminTemplateOptions)

Vue.config.productionTip = false;

(window as any).mobilecheck = isMobile

export default new Vue({
    router,
    i18n,
    store,
    'render': (h): VNode => h(App),
}).$mount('#app')
